



































import { Component, Vue } from "vue-property-decorator";
import BgmController from "@/components/molecules/BgmController.vue";
import { deviceType } from "mobile-device-detect";

@Component({
  components: {
    BgmController
  }
})
export default class AppHeaderBar extends Vue {
  public bgmController: BgmController;

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      this.bgmController = <BgmController> this.$refs.bgmController;
    });
  }
}
